import { render, staticRenderFns } from "./winner.vue?vue&type=template&id=67355eb5"
import script from "./winner.vue?vue&type=script&lang=js"
export * from "./winner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports